import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2, Shield } from 'lucide-react';
import { superApi } from '../../lib/superApi';

export default function SuperClient() {
  const [platform, setPlatform] = useState(null);
  const [savingLicense, setSavingLicense] = useState(false);

  const load = () =>
    superApi.get('/super/platform').then((r) => {
      setPlatform(r.data);
    });

  useEffect(() => {
    load().catch(() => toast.error('No se pudo cargar la plataforma'));
  }, []);

  const toggleLicense = async () => {
    setSavingLicense(true);
    try {
      const { data } = await superApi.put('/super/platform/admin-license', {
        admin_licensed: !platform.admin_licensed,
      });
      setPlatform(data);
      toast.success(data.admin_licensed ? 'Panel admin activado' : 'Panel admin desactivado');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Error');
    } finally {
      setSavingLicense(false);
    }
  };

  if (!platform) {
    return <div className="text-slate-400">Cargando…</div>;
  }

  const phaseLabel =
    {
      trial: 'Periodo de prueba',
      active: 'Suscripción activa',
      suspended: 'Suspendida',
    }[platform.subscription_phase] || platform.subscription_phase;

  return (
    <div className="space-y-8">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-teal-400">Plataforma</div>
        <h1 className="text-3xl font-semibold text-white mt-1">Cliente</h1>
        <p className="text-slate-400 text-sm mt-2">
          Kill switch de licencia y estado de suscripción de Pizas.
        </p>
      </div>

      <div className="rounded-lg border border-slate-800 bg-slate-900/60 p-5 space-y-2">
        <div className="text-sm text-slate-300">
          Fase: <span className="text-white font-medium">{phaseLabel}</span>
        </div>
        {platform.current_period_end && (
          <div className="text-sm text-slate-400">Vence: {platform.current_period_end}</div>
        )}
        {platform.trial_end_date && platform.subscription_phase === 'trial' && (
          <div className="text-sm text-slate-400">
            Prueba: {platform.trial_start_date} → {platform.trial_end_date}
          </div>
        )}
      </div>

      <div className="rounded-lg border border-slate-800 bg-slate-900/60 p-5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Shield className="text-teal-400" size={20} />
          <div>
            <div className="text-white font-medium">Panel de administración</div>
            <div className="text-xs text-slate-400">
              {platform.admin_licensed
                ? 'Licenciado — la clínica puede entrar'
                : 'Desactivado — bloquea login admin'}
            </div>
          </div>
        </div>
        <button
          type="button"
          onClick={toggleLicense}
          disabled={savingLicense}
          className={`inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm font-medium disabled:opacity-50 ${
            platform.admin_licensed
              ? 'border border-slate-600 text-slate-200 hover:bg-slate-800'
              : 'bg-teal-600 hover:bg-teal-500 text-white'
          }`}
        >
          {savingLicense ? <Loader2 className="animate-spin" size={14} /> : null}
          {platform.admin_licensed ? 'Desactivar acceso' : 'Activar acceso'}
        </button>
      </div>
    </div>
  );
}
